
import React from 'react'
import { MessageProps } from '../../MessageDisplayArea'
import { MessageSubtypes, MessageTypes } from '../constants/index'

const MessageTime: React.FC<MessageProps> = props => {
  const { message: { isFirstInGroup, date, time, type, subtype }, common: { showTime } } = props;
  const shouldShowTime = !!date
    && showTime
    && subtype !== MessageSubtypes.PREVIEW
    && (isFirstInGroup || type === MessageTypes.SYSTEM);

  if (!shouldShowTime) {
    return null;
  }

  return <p className="message-time">{time}</p>
};

export default MessageTime
